import React from 'react';
import AccruedRevenueReport from './AccruedRevenueReport';
import './AccruedRevenueReport.scss';

const AccruedRevenueReportMain = () => (
  <div className="accrued-revenue-report-wrapper">
    <div className="accrued-revenue-report-content">
      <AccruedRevenueReport />
    </div>
  </div>
);

export default AccruedRevenueReportMain;
